import { AllTopicsApi } from "@/api";

export async function getFrequented() {
  const { data } = await AllTopicsApi.getFrequented();
  return data;
}

export async function getTaught() {
  const { data } = await AllTopicsApi.getTaught();
  return data;
}

export async function getTeam(userActiveRole) {
  const { data } = await AllTopicsApi.getTeam(userActiveRole);
  return data;
}

export async function getFrequentedCourse() {
  const { data } = await AllTopicsApi.getFrequentedCourse();
  return data;
}

export async function getTaughtCourses() {
  const { data } = await AllTopicsApi.getTaughtCourses();
  return data;
}

export async function getTeamCourses(userActiveRole) {
  const { data } = await AllTopicsApi.getTeamCourses(userActiveRole);
  return data;
}
